module.exports = function() {
  return new Worker(__webpack_public_path__ + "4258c2ad2ac81854da87.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/app/utils/thin-out-sites/thin-out-sites-worker.js
// module id = 619
// module chunks = 1